import {BoxLayout} from '../../layout/BoxLayout';
import React from 'react';
import LoginHomePage from '../../auth/LoginHomePage';
import {Dialog} from '@mui/material';

export const Error504Page: React.FC<object> = () => (
  <BoxLayout>
    <Dialog fullScreen open={true}>
      <LoginHomePage />
    </Dialog>
  </BoxLayout>
);
